import { render, staticRenderFns } from "./addBankDetails.vue?vue&type=template&id=08ac84b1&scoped=true"
import script from "./addBankDetails.vue?vue&type=script&lang=js"
export * from "./addBankDetails.vue?vue&type=script&lang=js"
import style0 from "./addBankDetails.vue?vue&type=style&index=0&id=08ac84b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac84b1",
  null
  
)

export default component.exports